import { DataSourceAction, DataSourceExecutionEvent, DataSourceMode, DropdownItem,  DataDisplayEvent, Label,  ClickEvent,  TableRowDisplayEvent, Button, TableRow, Component, Textbox } from "@mcleod/components";
import { DateUtil, getConfig, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutUserSettings } from "./autogen/AutogenLayoutUserSettings";
import { CommonDialogs } from "./CommonDialogs";

interface TimeFormatItem extends DropdownItem {
  format: string;
}

export class UserSettings extends AutogenLayoutUserSettings {
  onLoad() {
    this.textTheme.items = ["Default", "Dark (experimental)"];
    this.textDateFormat.items = ["MM/dd/yy", "MM/dd/yyyy", "dd/MM/yyyy", "dd/MM/yy"];
    const civFormat = {caption: "Civilian", value: "C", format: "hh:mma"};
    const milFormat = {caption: "Military", value: "M", format: "HHmm"};
    this.textTimeFormat.items = [civFormat, milFormat];
    this.sourceSettings.data = [new ModelRow("common/user-system-config", true, { ...getConfig() })];
    this.sourceSettings.rowIndex = 0;
    this.sourceUserRecognizedDevice.search();
  }

  async buttonSaveClicked(event) {
    if (this.validateSimple()) {
      this.buttonSave.busy = true;
      Promise.all([this.sourceUsers.post(), this.sourceSettings.post(), this.sourceCurrentUserPowerbroker.post()]).then(() => {
        location.reload();
      })
      .catch(error => CommonDialogs.showError(error))
      .finally(() => this.buttonSave.busy = false)
    }
  }

  textDateFormatOnChange(event) {
    this.updateSample();
  }

  textTimeFormatOnChange(event) {
    this.updateSample();
  }

  updateSample() {
    const date = new Date();
    date.setFullYear(date.getFullYear(), 11, 31);
    date.setHours(16);
    date.setMinutes(35);
    let format;
    if (this.textDateFormat.selectedItem != null)
      format = (<TimeFormatItem>this.textDateFormat.selectedItem).caption;
    else
      format = "MM/dd/yyyy";
    format += " ";
    if (this.textTimeFormat.selectedItem != null)
      format += (<TimeFormatItem>this.textTimeFormat.selectedItem).format;
    else
      format += "hh:mma";
    this.labelSample.caption = DateUtil.formatDateTime(date, format);
  }

  sourceCurrentUserPowerbrokerAfterExecution(event: DataSourceExecutionEvent) {
    if (event.getAction() == DataSourceAction.SEARCH && this.sourceCurrentUserPowerbroker.activeRow == null) {
      this.sourceCurrentUserPowerbroker.mode = DataSourceMode.ADD;
    }
  }

  /** This is an event handler for the onClick event of buttonToggleDeviceApproval.  */
  buttonToggleDeviceApprovalOnClick(event: ClickEvent) {
    const tableRow = TableRow.getContainingTableRow(event.target as Component);
    tableRow.data.set("approved", tableRow.data.get("approved") === "N" ? "Y" : "N");
    tableRow.data.post().then(() => this.tableUserDevices.redisplaySingleRow(tableRow.index, tableRow.data, false, false));
  }

  /** This is an event handler for the onRowDisplay event of tableUserDevices.  */
  tableUserDevicesOnRowDisplay(event: TableRowDisplayEvent) {
    const button = event.getTableRow().findComponentById("buttonToggleDeviceApproval") as Button;
    if (event.getTableRow().data.get("approved") === "N")
      button.setProps({caption: "Unblock this Device", color: "success" });
    else
      button.setProps({caption: "Block this Device", color: "warning" });
  }

  /** This is an event handler for the onDataDisplay event of labelDeviceApproved.  */
  labelDeviceApprovedOnDataDisplay(event: DataDisplayEvent) {
    const label = event.target as Label;
    const tableRow = TableRow.getContainingTableRow(label);
    const thisDeviceId = localStorage.getItem("deviceId");
    if (tableRow.data.get("approved") === "N")
      label.setProps({caption: "Blocked", backgroundColor: "warning", color: "warning.reverse" });
    else if (tableRow.data.get("device_id") === thisDeviceId)
      label.setProps({caption: "This Device", backgroundColor: "success", color: "success.reverse" });
    else
      label.setProps({caption: "Approved", backgroundColor: "success", color: "success.reverse" });
  }

  /** This is an event handler for the onDataDisplay event of label1.  */
  labelDeviceLocationOnDataDisplay(event: DataDisplayEvent) {
    const label = event.target as Textbox;
    const tableRow = TableRow.getContainingTableRow(label);
    if (StringUtil.isEmptyString(tableRow.data.get("last_ip_location")))
      label.text = "Unknown location";
    label.tooltip = "IP address: " + tableRow.data.get("last_ip_address");
  }
}
